/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import './store';
import { namespace } from 'vuex-class';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { PreQueryChannleProduct } from '@/model/preApplyResult';

import RouterHelper from '@/shared/utils/routerHelper';
import { setPageTitle } from '@/api/native/utils';
import { Route } from 'vue-router';
import { ApplyOrderStatus } from './types';
import ApplySuccess from './components/apply-success';
import ApplyReject from './components/apply-reject';
import ApplyProcess from './components/apply-process';

const HomeStore = namespace('home');
const style = require('./index.module.scss');

const PreApplyResultStore = namespace('preApplyResult');

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);
@Component
export default class PreApplyResult extends Vue {
  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  /** 哈啰域内授信id */
  @Prop({
    type: String,
    required: false,
  })
  readonly taskId!: string;

  /** 外采授信三方订单 id */
  @Prop({
    type: String,
    required: false,
  })
  readonly sourceOrderId!: string;

  @PreApplyResultStore.State timerId!: NodeJS.Timer | null;

  @PreApplyResultStore.State
  applyData!: PreQueryChannleProduct.Infomation | null;

  @PreApplyResultStore.Action $resetState!: () => void;

  @PreApplyResultStore.Action getBannerConfig!: () => Promise<void>;

  @PreApplyResultStore.Action checkApplyResultWithInterval!: (payload: {
    taskId?: string;
    orderId?: string;
  }) => Promise<void>;

  private created() {
    if (this.taskId) {
      // 获取 风险评估 Banner配置
      this.getBannerConfig();
      // 启动接口轮询
      this.checkApplyResultWithInterval({
        taskId: this.taskId,
      });
    }

    if (this.sourceOrderId) {
      // 启动接口轮询
      this.checkApplyResultWithInterval({
        orderId: this.sourceOrderId,
      });
    }
  }

  /** 是否外采授信订单 */
  private get isOutOrder(): boolean {
    return !!this.sourceOrderId;
  }

  private ubtBackName = '';

  // 监听申请结果变化情况
  @Watch('applyData')
  private onApplyDataUpdated() {
    let pageTitle = '审核结果';
    let ubtButtonName = '';
    let ubtExposeName = '';
    let shouldConfirmOnBack: boolean | string = 'default';
    if (this.applyData) {
      switch (this.applyData.status) {
        case ApplyOrderStatus.SUBMITTING:
          pageTitle = this.isOutOrder ? '资料审核中' : '额度申请中';
          ubtButtonName = '臻有钱_资料提交成功页';
          ubtExposeName = 'finance_applyresultload';
          this.ubtBackName = 'finance_applyresultload_return';
          break;

        case ApplyOrderStatus.SUCCEEDED:
          // 授信成功之后刷新首页额度，避免回退到首页出现首页版本显示不对的问题
          this.getCreditData();

          pageTitle = '审核结果';
          ubtButtonName = '臻有钱_资料审核通过页';
          ubtExposeName = 'finance_applyresultpass';
          this.ubtBackName = 'finance_applyresultpass_return';
          shouldConfirmOnBack = false;
          break;

        case ApplyOrderStatus.FAILED:
          pageTitle = '审核结果';
          ubtButtonName = '臻有钱_审核不通过页';
          ubtExposeName = 'finance_applyresultfail';
          this.ubtBackName = 'finance_applyresultfail_return';
          shouldConfirmOnBack = false;
          break;

        default:
          break;
      }

      /** 延迟50ms，以解决路由 setPageTitle 晚于当前方法触发的情况 */
      setTimeout(() => {
        setPageTitle(pageTitle);
      }, 50);
      RouterHelper.setBackConfirm(shouldConfirmOnBack);
      this.$ubtPageButton(ubtButtonName, '状态', this.applyData.status);
      this.$ubtModuleExpose(ubtExposeName, '状态', this.applyData.status);
    }
  }

  /** 返回 */
  private beforeRouteLeave(
    to: Route,
    from: Route,
    next: (...d: unknown[]) => void,
  ) {
    this.$ubtPageButton(this.ubtBackName);
    RouterHelper.useNext(next, to, from);
  }


  private render() {
    let applyResult = null;

    if (this.applyData) {
      switch (this.applyData.status) {
        case ApplyOrderStatus.SUBMITTING:
          applyResult = <ApplyProcess outOrder={this.isOutOrder}/>;
          break;

        case ApplyOrderStatus.SUCCEEDED:
          applyResult = <ApplySuccess applyResultSuccess={this.applyData}/>;
          break;

        case ApplyOrderStatus.FAILED:
          applyResult = <ApplyReject outOrder={this.isOutOrder}/>;
          break;

        default:
          break;
      }
    }

    return (
      <div class={style.pageContainer}>
        {applyResult}
      </div>
    );
  }

  // 清除定时器
  private beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.$resetState();
    }
  }
}
